import { add_from_serialized } from "../commands/commands";
import { B_AttrFlags, BBase, forceSetAutoId, getCurrentAutoId, push_or_insert } from "./BBase";
import BBuilding from "./BBuilding";
import BFloor from "./BFloor";
import BPolyline from "./BPolyline";

class BProject extends BBase {
	constructor(flags, forceSetId) {
		super(flags, forceSetId);
		this.idmap = new Map();

		this.buildings = [];
		this.buildingNameList = [];
		this.activeBuildingIndex = -1;

		this.defaultAltStep = 50;
		this.idmap.set(this.id, this);
	}

	onAddToTree(newItem) {
		if (this.idmap.has(newItem.id)) {
			console.log(`%cDuplicated ID: ${newItem.id}`, "color:#F00");
		}

		this.idmap.set(newItem.id, newItem);
	}

	findById(id) {
		return 	this.idmap.get(id) ?? null;
	}

	setupTemplate() {
		const b = new BBuilding();
		this.addBuilding(b);

		const colorIndex = b.generateNextFloorColorIndex();

		const f = new BFloor();
		f.title = "1F";
		f.setEditorColorByPresetIndex(colorIndex);
		b.addItem(f);

		const pl = create_simple_rect(50, B_AttrFlags.BuildingOuter);
		f.addItem(pl);

		this.activeBuildingIndex = 0;
		this.updateBuildingNameList();
	}

	get activeBuilding() {
		return this.buildings[ this.activeBuildingIndex ] || null;
	}

	addBuilding(b) {
		push_or_insert(this.buildings, b, -1);
		b.setEventParent(this);
	}

	eachBuilding(fn) {
		this.buildings.forEach(fn);
	}

	updateBuildingNameList() {
		this.buildingNameList.length = 0;
		this.eachBuilding( b => {
			this.buildingNameList.push(b.title);
		});
	}

	willDispose(item) {
		this.idmap.delete(item.id);
	}

	serialize() {
		const o = super.serialize();
		o.buildings = [];
		o.nextAutoId = getCurrentAutoId();
		o.activeBuildingIndex = this.activeBuildingIndex;

		this.eachBuilding( b => {
			o.buildings.push( b.serialize() );
		});

		return o;
	}

	deserialize(o) {
		this.activeBuildingIndex = o.activeBuildingIndex;
		
		o.buildings.forEach( b => {
			add_from_serialized(null, b, this)
		} )

		if (Number.isFinite(o.nextAutoId)) {
			forceSetAutoId(o.nextAutoId);
		}
	}
}

function simple_line_coordinates(span) {
	return [ [-span, 0], [span, 0] ];
}

function create_simple_rect(span, flags) {
	const pl = new BPolyline(flags);
	pl.addLoop( simple_rect_coordinates(span) );
	return pl;
}

function simple_rect_coordinates(span) {
	if (!span) {
		span = 50;
	}

	return [
		[-span,  span],
		[ span,  span],
		[ span, -span],
		[-span, -span]
	];
}

export { create_simple_rect, simple_rect_coordinates, simple_line_coordinates };
export default BProject;